import { Button as BsButton, type ButtonProps } from 'react-bootstrap'
import classNames from 'classnames'
import type { ReactNode } from 'react'

export type Properties = ButtonProps & {
  icon?: ReactNode
  iconPosition?: 'left' | 'right'
  spanClassName?: string
  isInline?: boolean
  ref?: React.Ref<HTMLButtonElement>
  htmlFor?: string
}

export const Button: React.FC<Properties> = ({
  children,
  className,
  icon,
  iconPosition = 'left',
  spanClassName,
  isInline = false,
  ...properties
}) => {
  return (
    <BsButton
      {...properties}
      className={classNames(
        'gap-2 justify-content-center align-items-center',
        isInline ? 'd-inline-flex' : 'd-flex',
        className
      )}
    >
      {iconPosition === 'left' && icon}
      <span className={spanClassName}>{children}</span>
      {iconPosition === 'right' && icon}
    </BsButton>
  )
}
